import { telemetry as telemetryLib } from "@root/lib/telemetry";
import { ITelemetryProperty } from "./telemetry-property";

export class Telemetry {
  public trackEvent(eventName: string, props?: ITelemetryProperty): void {
    telemetryLib.trackEvent(eventName, props);
  }

  public trackException(exception: any, props?: ITelemetryProperty): void {
    telemetryLib.trackException(exception, props);
  }
}

export const telemetry: Telemetry = new Telemetry();
